// extracted by mini-css-extract-plugin
module.exports = {"activity":"activity__L02DA","head":"head__JQ2oH","avatarWrap":"avatarWrap__gg9id","avatar":"avatar__S32Ng","info":"info__s-iTg","content":"content__YsmlL"};